__turbopack_context__.v({
  "tabsContainer": "shops-module-scss-module__xWrqfW__tabsContainer",
  "topPanelWrap": "shops-module-scss-module__xWrqfW__topPanelWrap",
});
